$modal-background: 'rgba(0, 0, 0, 0.6)' !default;

.modal-backdrop {
  background: #{$modal-background} !important;
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/recipe/editor/modal/modal-theme.scss